import React, { useCallback, useMemo, useState } from 'react';
import Nav from 'react-bootstrap/Nav';
import Dropdown from 'react-bootstrap/Dropdown';

interface Props {
	defaultActiveTabId: string;
	activeTabId: string;
	baseTabId: string;
	/**
	 * List of tabs { id, title }
	 */
	tabs: {
		id: string;
		title: string;
	}[];
	onSelect: (key: string) => void;
}

/**
 * Collapsable menu
 */
function CollapsableMenu(props: Props) {
	const { tabs, defaultActiveTabId, activeTabId, baseTabId, onSelect } = props;

	const selectedDropDownMenuItem = useMemo(() => {
		return tabs.find((tab) => tab.id === activeTabId);
	}, [activeTabId, tabs]);

	return (
		<div className='mb-3'>
			<div className='d-none d-md-inline'>
				<Nav
					id='nav-menuItems'
					justify
					variant='pills'
					className='justify-content'
					defaultActiveKey={defaultActiveTabId}
				>
					{tabs.map((tab) => {
						return (
							<Nav.Item key={tab.id} id={tab.id}>
								<Nav.Link
									href='#'
									id={tab.id + '-tab'}
									eventKey={tab.id}
									className={tab.id}
									onClick={() => {
										onSelect(tab.id);
									}}
								>
									<span>{tab.title}</span>
								</Nav.Link>
							</Nav.Item>
						);
					})}
				</Nav>
			</div>

			<Dropdown className='nav-tabs d-md-none'>
				<Dropdown.Toggle id='dropdown-menuItems' style={{ display: 'block', width: '100%' }}>
					{selectedDropDownMenuItem?.title}
				</Dropdown.Toggle>

				<Dropdown.Menu style={{ width: '100%' }}>
					{tabs.map((tab) => {
						return (
							<Dropdown.Item
								className='nav-item'
								key={tab.id}
								onClick={() => {
									onSelect(tab.id);
								}}
							>
								{tab.title}
							</Dropdown.Item>
						);
					})}
				</Dropdown.Menu>
			</Dropdown>
		</div>
	);
}
export default CollapsableMenu;
